import { AuthenticatorProps } from "@aws-amplify/ui-react/dist/types/components/Authenticator/Authenticator";
import { Auth } from "aws-amplify";

export const authServices: AuthenticatorProps["services"] = {
  async handleSignUp(formData) {
    try {
      return await Auth.signUp({
        ...formData,
        autoSignIn: {
          enabled: true,
        },
      });
    } catch (error: unknown) {
      if (error instanceof Error && error.message.includes("email already exists")) {
        const duplicateEmailError = new Error(
          "An account with this email address already exists. Please use a different email or sign in."
        );
        duplicateEmailError.name = error.name;
        throw duplicateEmailError;
      } else if (error instanceof Error && error.message.includes("User already exists")) {
        const duplicateUserError = new Error(
          "An account with this username already exists. Please choose a different username."
        );
        duplicateUserError.name = error.name;
        throw duplicateUserError;
      }
      throw error;
    }
  },

  async handleForgotPassword(username) {
    try {
      return await Auth.forgotPassword(username);
    } catch (error: unknown) {
      if (
        error instanceof Error &&
        (error.message.includes("Username cannot be empty") ||
          error.message.includes("Username/client id combination not found") ||
          error.message.includes("Cannot reset password for the user as there is no registered/verified email"))
      ) {
        const userFriendlyError = new Error("Please enter a valid username or email");
        userFriendlyError.name = error.name;
        throw userFriendlyError;
      }
      throw error;
    }
  },

  async handleForgotPasswordSubmit(formData) {
    return await Auth.forgotPasswordSubmit(formData.username, formData.code, formData.password);
  },
};
